import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";

class CreateEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      description: "",
      type: "",
      Configuration: "",
      status: "1",
      name_error: false,
      config_error: false,
      invalid_json: false,
      type_error: false
    };
    this.formSubmit = false;
  }
  async componentDidMount() { }

  handleNameChange = (e) => {
    console.log(e.target.value);
    if (e.target.value == '') {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }
  handleDescriptionChange = (e) => {
    console.log(e.target.value);
    this.setState({ description: e.target.value });
  }
  handleTypeChange = (e) => {
    console.log(e.target.value);
    if (e.target.value == '') {
      this.setState({ type_error: true });
    } else {
      this.setState({ type_error: false });
    }
    this.setState({ type: e.target.value });
  }
  handleConfigChange = (e) => {
    console.log(e.target.value);

    this.setState({ Configuration: e.target.value });
    if (e.target.value == '') {
      this.setState({ config_error: true });
      this.setState({ invalid_json: false })

    } else {
      this.setState({ config_error: false });
      try {
        JSON.parse(e.target.value)
        this.setState({ invalid_json: false })
      } catch (e) {
        console.log(`parsing failed ${e}`)
        this.setState({ invalid_json: true })
      }
    }
  }
  handleStatusChange = (e) => {
    console.log(e.target.value);
    this.setState({ status: e.target.value });

  }

  handleSubmit = async () => {
    this.formSubmit = true;

    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }
    if (this.state.type == "") {
      this.setState({ type_error: true });
      this.formSubmit = false;
    }
    if (this.state.Configuration == "") {
      this.setState({ config_error: true });
      this.formSubmit = false;
    }
    if (this.state.invalid_json) {
      this.formSubmit = false;
    }

    if (this.formSubmit) {
      this.props.setLoadingPageAction(true);

      try {
        await axios.post(
          `${apiHost}/api/Event/EventRegister`,
          {
            Name: this.state.name,
            Description: this.state.description,
            Type: this.state.type,
            Config: this.state.Configuration,
            Status: this.state.status,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        );

        this.props.setLoadingPageAction(false);
        this.props.history.push("/events");
      } catch (e) {
        this.props.setLoadingPageAction(false);
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          if (e.response.status == "305") {
            this.props.setErrorMessageAction("Invalid Json Format in Configuration");
          }
          else {
            this.props.setErrorMessageAction(`${e}`);
          }
        }
        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }
  render() {
    return (
      <div>
        <Layout>
          <Helmet>
            <title>Create Event </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Create Event</h2>
              <h6>Create a new Event</h6>
              <hr></hr>
              <Form>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input">Name</span>
                  </Form.Label>
                  <Col sm={3}>
                    <Form.Control
                      type="text"
                      onChange={this.handleNameChange}
                    />
                    <p
                      style={
                        this.state.name_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Description</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      onChange={this.handleDescriptionChange}
                      rows="2"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Type</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      type="number"

                      onChange={this.handleTypeChange}
                    />
                    <p
                      style={
                        this.state.type_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Type field is required.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Configuration</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      as="textarea"
                      rows="3"

                      onChange={this.handleConfigChange}
                    />
                    <p
                      style={
                        this.state.config_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Configuration field is required.
                    </p>
                    <p
                      style={
                        this.state.invalid_json
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      Invalid Json.
                    </p>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                  <Form.Label column sm={2}>
                    <span className="inline-input"> Status</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control as="select" onChange={this.handleStatusChange}>
                      <option value="1">Active</option>
                      <option value="0">Disabled</option>

                    </Form.Control>
                  </Col>
                </Form.Group>
                <div className="footer-menu">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => {
                      this.props.history.push("/events");
                    }}
                  >
                    Back to List
                  </Button>
                  &nbsp;
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={this.handleSubmit}
                  >
                    Create
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.loading
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateEvent);
